export class NavigationHelper {
  // Returns if the user is currently of a Turbo-generated from cache
  // version of the page or the "real" fresh page
  static pageIsPreview() {
    return document.documentElement.hasAttribute("data-turbo-preview")
  }
}
